// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__xVdCQ","tab":"Tabs_tab__2dVEP","tabActive":"Tabs_tabActive__2_lGl"};